import {ComponentProps} from 'react';

import {useInputTagContext} from './input-tag-context';
import {Tag} from './tag';

type Props = Omit<ComponentProps<typeof Tag>, 'selected' | 'onDelete' | 'onUnselect'>;

export const TagConnected = ({label, ...props}: Props) => {
    const context = useInputTagContext();

    return (
        <Tag
            {...props}
            label={label}
            selected={context.selectedTag === label}
            onDelete={context.removeTag}
            onUnselect={context.unselectTag}
        />
    );
};
